'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("etatDetteService", function ($dateFormat, $modal, contextService, $http, $authz, $q, budgetService) {
  /**
   * en dette propre, maintient les paramètres du formulaire de manière à pouvoir le partager entre la page etat de la dette et icne comptables
   * @type {null}
   */
  var params = null;
  function _getAnneeParDefaut() {
    var dateVisualisation = contextService.getContext().dateVisualisation;
    // changement d'annee au 1er aout : annee precedente, annee courante
    return moment(dateVisualisation).month() < 8 ? moment(dateVisualisation).year() - 1 : moment(dateVisualisation).year();
  }
  function _getMaquetteIdParDefaut() {
    var maquetteId;
    if ($authz.hasRole("RAPPORT_ETAT_DE_LA_DETTE_M4")) {
      maquetteId = 'M4';
    } else if ($authz.hasRole("RAPPORT_ETAT_DE_LA_DETTE_M14")) {
      maquetteId = 'M14';
    } else if ($authz.hasRole("RAPPORT_ETAT_DE_LA_DETTE_M21")) {
      maquetteId = 'M21';
    } else if ($authz.hasRole("RAPPORT_ETAT_DE_LA_DETTE_M52")) {
      maquetteId = 'M52';
    } else if ($authz.hasRole("RAPPORT_ETAT_DE_LA_DETTE_M57")) {
      maquetteId = 'M57';
    } else if ($authz.hasRole("RAPPORT_ETAT_DE_LA_DETTE_M61")) {
      maquetteId = 'M61';
    } else if ($authz.hasRole("RAPPORT_ETAT_DE_LA_DETTE_M71")) {
      maquetteId = 'M71';
    }
    return maquetteId;
  }
  function _getPlansComptablesAccessibles() {
    var plansComptablesAccessibles;
    var planComptablePrincipal = _getMaquetteIdParDefaut();
    if (planComptablePrincipal === 'M4') {
      plansComptablesAccessibles = [{
        id: 'M4'
      }, {
        id: 'M14'
      }, {
        id: 'M57'
      }];
    } else if (planComptablePrincipal === 'M14') {
      plansComptablesAccessibles = [{
        id: 'M14'
      }, {
        id: 'M4'
      }, {
        id: 'M57'
      }];
    } else if (planComptablePrincipal === 'M21') {
      plansComptablesAccessibles = [{
        id: 'M21'
      }];
    } else if (planComptablePrincipal === 'M52') {
      plansComptablesAccessibles = [{
        id: 'M52'
      }, {
        id: 'M4'
      }, {
        id: 'M22'
      }, {
        id: 'M57'
      }];
    } else if (planComptablePrincipal === 'M57') {
      plansComptablesAccessibles = [{
        id: 'M57'
      }, {
        id: 'M4'
      }, {
        id: 'M14'
      }];
    } else if (planComptablePrincipal === 'M61') {
      plansComptablesAccessibles = [{
        id: 'M61'
      }, {
        id: 'M57'
      }];
    } else if (planComptablePrincipal === 'M71') {
      plansComptablesAccessibles = [{
        id: 'M71'
      }, {
        id: 'M57'
      }];
    }
    return plansComptablesAccessibles;
  }
  function _getTypeBudgetParDefaut() {
    return 'CA';
  }
  return {
    /**
     * recupération synchrone. Doit etre initialisé via un getOrInitParams pour la dette propre pour que les budgets soient bien chargés avant et pouvoir selectionner le budget principal par defaut
     * @returns {null}
     */
    getParams: function getParams() {
      return params;
    },
    /**
     * a utiliser si il n'y a pas besoin d'asynchrone dans l'init (ou géré par l'appelant)
     * @param p
     */
    setParams: function setParams(p) {
      params = p;
    },
    /**
     *pour la dette propre uniquement
     * @returns params, sous forme de promise (asynchrone de manière à pouvoir initialiser avec le budget principal par défaut )
     */
    getOrInitParams: function getOrInitParams() {
      if (params != null) {
        return $q.when(params);
      }
      var defer = $q.defer();
      $http.get('/rest/budgets').then(function (response) {
        var budgets = budgetService.flattenTree(response.data);
        var budgetId = null;
        var planComptablePrincipal = null;
        _.each(budgets, function (b) {
          if (b.type === 'PRINCIPAL') {
            budgetId = b.id;
            planComptablePrincipal = b.planComptable;
          }
        });
        if (planComptablePrincipal == null) {
          planComptablePrincipal = _getMaquetteIdParDefaut();
        }
        params = {
          annee: _getAnneeParDefaut(),
          type: _getTypeBudgetParDefaut(),
          maquetteId: planComptablePrincipal,
          plansComptablesAccessibles: _getPlansComptablesAccessibles(),
          dateDeVote: moment().hour(0).minute(0).second(0).toDate(),
          budgetId: budgetId,
          garanties: true // plus d'actualité normalement
        };
        return defer.resolve(params);
      });
      return defer.promise;
    },
    getMaquetteIdParDefaut: function getMaquetteIdParDefaut() {
      return _getMaquetteIdParDefaut();
    },
    getPlansComptablesAccessibles: function getPlansComptablesAccessibles() {
      return _getPlansComptablesAccessibles();
    },
    getAnneeParDefaut: function getAnneeParDefaut() {
      return _getAnneeParDefaut();
    },
    getTypeBudgetParDefaut: function getTypeBudgetParDefaut() {
      return _getTypeBudgetParDefaut();
    },
    getTypesEtatDette: function getTypesEtatDette() {
      return [{
        'id': 'CA',
        label: 'Compte Administratif / CFU'
      }, {
        'id': 'BP',
        label: 'Budget Primitif'
      }, {
        'id': 'BS',
        label: 'Budget Supplémentaire'
      }, {
        'id': 'DM',
        label: 'Décision Modificative'
      }];
    },
    getAnnees: function getAnnees() {
      var annees = [];

      // 10 ans après l'année courante
      for (var a = 2014; a < this.getAnneeParDefaut() + 10; a++) {
        annees.push({
          'id': a,
          label: '' + a
        });
      }
      return annees;
    },
    /**
     *  * @param etatDette un objet avec la structure :
     * etatDette = {
            annee: ,
            type: ,
            budgetId: ,
            dateDeVote:
        };
     */
    getDownloadUrl: function getDownloadUrl(maquette, etat, etatDette) {
      var url = '/rest/etat-dette/' + maquette + '/' + etat + '/' + etatDette.type + '/xls?annee=' + etatDette.annee;
      if (etatDette.budgetId != null) {
        url += '&budgetId=' + etatDette.budgetId;
      }
      if (etatDette.type === 'BS' || etatDette.type === 'DM' && etatDette.dateDeVote != null) {
        url += '&dateDeVote=' + $dateFormat.server(etatDette.dateDeVote);
      }
      return url;
    },
    /**
     *  * @param etatDette un objet avec la structure :
     * etatDette = {
            annee: ,
            type: ,
            budgetId: ,
            dateDeVote:
        };
     */
    getDgDownloadUrl: function getDgDownloadUrl(maquette, etat, etatDette) {
      var url = '/rest/dette-garantie/reporting/etat-dette/' + maquette + '/' + etat + '/' + etatDette.type + '/xls?annee=' + etatDette.annee + "&afficherReference=" + etatDette.afficherReference;
      if (etatDette.type === 'BS' || etatDette.type === 'DM' && etatDette.dateDeVote != null) {
        url += '&dateDeVote=' + $dateFormat.server(etatDette.dateDeVote);
      }
      return url;
    },
    /**
     *
     * @param etatDette un objet avec la structure :
     * etatDette = {
            annee: ,
            type: ,
            budgetId: ,
            dateDeVote:
        };
     */
    getTotemDownloadUrl: function getTotemDownloadUrl(etatDette, typeProduit, zip) {
      if (etatDette == null) return "#";
      var url = '/rest/etat-dette/dematerialisation/';
      if (zip) {
        url = '/rest/etat-dette/dematerialisation/zip/';
      }
      if (typeProduit) {
        url += typeProduit + '/';
      }
      url += etatDette.type + '?annee=' + etatDette.annee;
      if (etatDette.budgetId != null && etatDette.budgetId !== "") {
        url += '&budgetId=' + etatDette.budgetId;
      }
      if (etatDette.type === 'BS' || etatDette.type === 'DM' && etatDette.dateDeVote != null) {
        url += '&dateDeVote=' + $dateFormat.server(etatDette.dateDeVote);
      }
      if (etatDette.afficherReference === true) {
        url += '&afficherReference=true';
      }
      url += '&garanties=false';
      url += '&plan=' + etatDette.maquetteId;
      return url;
    },
    openAideTotem: function openAideTotem() {
      return $modal.open({
        template: require("./totem/aideTotem.html"),
        options: {
          width: 1200
        }
      });
    },
    registerEtatDetteWatcherForVerification: function registerEtatDetteWatcherForVerification($scope) {
      var verificationEnCours = false;
      var relancerVerification = false;
      function verifieDonnees() {
        // Si une vérification est déjà en cours, on note qu'il faudra la relancer et on arrête là.
        if (verificationEnCours) {
          relancerVerification = true;
          return;
        }
        verificationEnCours = true;
        relancerVerification = false; // On va lancer la vérification, on reset le flag.
        $scope.loadVerification = true;
        $http.get('/rest/etat-dette/verifie-donnees/' + $scope.etatDette.maquetteId, {
          params: $scope.etatDette
        }).then(function (response) {
          $scope.verification = response.data;
        }).finally(function () {
          verificationEnCours = false;
          $scope.loadVerification = false;

          // Si une nouvelle demande a été faite pendant l'appel, on relance.
          if (relancerVerification) {
            verifieDonnees();
          }
        });
      }
      $scope.$watch('etatDette', function () {
        verifieDonnees();
      }, true);
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/services/etatDetteService.js
// module id = 2870
// module chunks = 13